import { useRecoilState, useRecoilValue } from "recoil";
import { dialogState } from "../../recoil/dialog.atom";
import { DialogWrapper } from "./style";
import { WideState } from "../../recoil/wide";

const Dialog = () => {
  const [dialog, setDialog] = useRecoilState(dialogState);
  const isWide = useRecoilValue(WideState);

  if (!dialog) {
    return <></>;
  }
  return (
    <DialogWrapper isCancel={dialog.isCancel !== false} isWide={isWide}>
      <div className="title">{dialog.title}</div>
      <div className="button-wrapper">
        {dialog.isCancel !== false && (
          <div className="cancel-button" onClick={() => setDialog(null)}>
            취소
          </div>
        )}
        <div
          className="create-button"
          onClick={async () => {
            if (dialog.confirm) {
              await dialog.confirm();
            }
            setDialog(null);
          }}
        >
          확인
        </div>
      </div>
    </DialogWrapper>
  );
};

export default Dialog;
